import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EndpointKey } from '../../http/EndpointKey';
import Logger from '../../lib/Logger';
import { retryEndpoint } from '../../store/http-responses/action-creators';
import { useTracker } from '../../tracking/useTracker';
import { getIsVerificationExpired, getIsNewUser, getIsCompleteVerificationCompleteValue } from '../../store/app/selectors';
import { isOAuthSignup } from '../../app/verificationTypeSelectors';
const LOG = Logger.getLogger('useRecaptchaChallenge');
export const useRecaptchaChallenge = () => {
  const Tracker = useTracker();
  const dispatch = useDispatch();
  const [isChallengeResolved, setIsChallengeResolved] = useState(false);
  const completeVerificationIsNotFinished = !useSelector(getIsCompleteVerificationCompleteValue);
  const isVerificationExpired = useSelector(getIsVerificationExpired);
  const isNewUser = useSelector(getIsNewUser);
  const getIsOAuthSignup = useSelector(isOAuthSignup);
  const isInitiateVerification = isNewUser && !getIsOAuthSignup && (completeVerificationIsNotFinished || isVerificationExpired);
  useEffect(() => {
    const subscreen = isInitiateVerification ? 'initiate-verification' : 'signup';
    Tracker.signupInteraction('creation-error-recaptcha-fallback', {
      subscreen
    });
    if (isInitiateVerification) {
      Tracker.signupInteraction('initiate-verification-recaptcha-fallback');
    }
  }, [isInitiateVerification, Tracker]);
  const onClick = () => {
    if (isInitiateVerification) {
      dispatch(retryEndpoint(EndpointKey.InitiateVerification, 2200));
    } else {
      dispatch(retryEndpoint(EndpointKey.Signup, 2200));
    }
  };
  const onResolvedHandler = useCallback(() => {
    setIsChallengeResolved(true);
  }, [setIsChallengeResolved]);
  const onExpiredHandler = useCallback(() => {
    setIsChallengeResolved(false);
  }, [setIsChallengeResolved]);
  const onErrorHandler = useCallback(error => {
    LOG.error(`Recaptcha returned an error: ${error}`);
    setIsChallengeResolved(false);
  }, [setIsChallengeResolved]);
  return {
    isChallengeResolved,
    onClick,
    onErrorHandler,
    onExpiredHandler,
    onResolvedHandler
  };
};